var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4512 3.80469H1.57891C1.1835 3.80469 0.804291 3.96188 0.524697 4.24167C0.245102 4.52147 0.088028 4.90095 0.088028 5.29665V20.2162C0.088028 20.6119 0.245102 20.9914 0.524697 21.2712C0.804291 21.551 1.1835 21.7082 1.57891 21.7082H22.4512C22.8466 21.7082 23.2259 21.551 23.5054 21.2712C23.785 20.9914 23.9421 20.6119 23.9421 20.2162V5.29665C23.9421 4.90095 23.785 4.52147 23.5054 4.24167C23.2259 3.96188 22.8466 3.80469 22.4512 3.80469V3.80469ZM21.3033 20.2162H2.81634L8.03442 14.8153L6.96099 13.7784L1.57891 19.3509V6.43054L10.8447 15.6583C11.1241 15.9362 11.5019 16.0922 11.8958 16.0922C12.2897 16.0922 12.6675 15.9362 12.9469 15.6583L22.4512 6.19928V19.2539L16.9648 13.7635L15.9137 14.8153L21.3033 20.2162ZM2.55543 5.29665H21.2436L11.8958 14.599L2.55543 5.29665Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEmail);
export default __webpack_public_path__ + "static/media/logoEmail.0e9e9fe4bd44d774c3a22df98a13704f.svg";
export { ForwardRef as ReactComponent };